import { AccountPlan } from 'hooks/use-account-plans.hook';
import { UserData } from 'hooks/use-user.hook';

interface EnvelopeDocuSignPcMap {
  status: string;
  personalizedContractId: string;
  completedFile: string | null;
  envelopeUpdatedAt: string;
}

export const getPersonalizedContractEnvelopes = (
  user: UserData
): EnvelopeDocuSignPcMap[] => {
  const userDocuSignEnvelopes = user?.userDocuSignEnvelopes;
  if (!userDocuSignEnvelopes) return [];

  const userDocuSignEnvelopesPcStatusMap = userDocuSignEnvelopes
    .map(envelope => {
      if (
        !envelope?.status ||
        !envelope?.personalizedContractId ||
        !envelope?.envelopeUpdatedAt
      ) {
        return;
      }
      return {
        status: envelope.status,
        personalizedContractId: envelope.personalizedContractId,
        completedFile: envelope.completedFile,
        envelopeUpdatedAt: envelope.envelopeUpdatedAt,
      };
    })
    .filter(
      (envelope): envelope is EnvelopeDocuSignPcMap => envelope !== undefined
    );

  return userDocuSignEnvelopesPcStatusMap.length > 0
    ? userDocuSignEnvelopesPcStatusMap
    : [];
};

export const getUtilityAccountPersonalizedContracts = (
  plans: AccountPlan[]
) => {
  return plans.map(plan => {
    return {
      utilityAccountId: plan?.utilityAccounts[0]?.id,
      personalizedContracts:
        plan?.utilityAccounts[0]?.utilityAccountPersonalizedContracts,
    };
  });
};
